export default __webpack_public_path__ + "media/images/images/svg/cd-arrow-ed1d2e29ef1ba6b0c9c8754473a7f6cc.svg";